import React from "react";
import { Card as MuiCard } from "@mui/material";

export const Card = ({ children, secondary, padding = "3rem", sx }) => {
  return (
    <MuiCard
      variant="outlined"
      sx={{
        backgroundColor: secondary ? "background3.light" : "background4.main",
        border: (theme) => `1px solid ${secondary ? theme.palette.background3.dark : theme.palette.primary.main}`,
        borderRadius: 0,
        padding: padding,
        ...sx,
      }}
    >
      {children}
    </MuiCard>
  );
};
